export default {"src":"/_next/static/media/gmail.f6e11c11.svg","height":72,"width":193,"blurWidth":0,"blurHeight":0};